var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 285,
    viewBox: "0 0 380 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M380 45.5L242.5 49.5L229 98L367.5 94L380 45.5Z",
    fill: "#002DD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.5 0L60 5.5L23.5 150L168 146.5L155.5 192L11.5 197L0 243L144.5 238L132 285L319.5 279.5L331.5 234.5L191.5 238L204 192L341 188.5L353.5 142.5L215.5 146.5L229 98L85 102L98.5 53L242.5 49.5L255.5 0Z",
    fill: "#002DD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.f6066135358c9d8726dc2ae743cc8ca1.svg";
export { ForwardRef as ReactComponent };